import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SnackbarService } from '../../_service/message-service';
import { Subject, Subscription } from 'rxjs';
import { UserService } from 'src/app/_services';
import { phoneNumberValidator } from 'lac-mat-tel-input';
import { UserInfoService } from 'src/app/_services/userInfo.service';

@Component({
  selector: 'telio-service-request',
  templateUrl: './service-request.component.html',
  styleUrls: ['./service-request.component.scss']
})
export class ServiceRequestComponent implements OnInit, OnDestroy {
  subscriptions = new Subscription();
  dtTrigger = new Subject();
  vendormailid;
  mobilenumber;
  userdetails;
  numberAllow: string;
  serviceForm: UntypedFormGroup;
  emailRegEX: RegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@,"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  mobNumberPattern = "^((\\+91-?)|0)?[0-9]{10}$";
  selectedFile = null;
  countries = ['us', 'in'];
  ticketData: any;
  formdetails;
  selectedFilePreview = null;

  constructor(private formBuilder: UntypedFormBuilder,
    private route: Router,
    private toastr: SnackbarService,
    private userInfoService: UserInfoService,
    public translate: TranslateService,
    private userservice: UserService,
    readonly routed: ActivatedRoute) { }

  onFileSelected1(event) {
    this.selectedFile = event.target.files[0];
    var fileName = this.selectedFile.name;
    var imageSize = event.target.files[0].size
    var idxDot = fileName.lastIndexOf(".") + 1;
    var extFile = fileName.substr(idxDot, fileName.length).toLowerCase();
    if (imageSize > 10485760) {
      this.toastr.error(this.translate.instant('serviceRequest.imageError1'))
      event.target.value = null;
      return false
    }
    if (extFile == "jpg" || extFile == "jpeg" || extFile == "png") {
      return true
    } else {
      this.toastr.error(this.translate.instant('serviceRequest.imageError2'))
      event.target.value = null;
      return false
    }
  }

  onFileSelected(event) {
    let x = event.target.files[0];
    this.selectedFile = x;
    var fileName = x.name
    var imageSize = x.size
    var idxDot = fileName.lastIndexOf(".") + 1;
    var extFile = fileName.substr(idxDot, fileName.length).toLowerCase();
    if (imageSize > 1048576) {
      this.toastr.error(this.translate.instant('createStation.uploadimgSizeError'))
      event.target.value = null;
      return false
    }
    if (extFile == "jpg" || extFile == "jpeg" || extFile == "png") {
      let reader = new FileReader();
      let url;
      reader.onload = () => {
        url = reader.result;
        this.selectedFilePreview = url;
      };
      reader.readAsDataURL(x);
    } else {
      this.toastr.error(this.translate.instant('createStation.imgTypeError'));
      event.target.value = null;
      return false
    }
  }

  ngOnInit(): void {
    this.countries = this.userInfoService.countryList;
    this.userdetails = this.userInfoService.userDetails;
    this.vendormailid = this.userdetails.email;
    this.mobilenumber = this.userdetails.mobileNo
    this.serviceForm = new UntypedFormGroup({
      mobile: new UntypedFormControl(),
      description: new UntypedFormControl(),
      queryType: new UntypedFormControl()
    })
    this.serviceForm = this.formBuilder.group({
      user: new UntypedFormControl({ value: this.vendormailid, disabled: true }, Validators.required),
      mobile: [null, Validators.compose([Validators.required,
        phoneNumberValidator
      ])],
      description: [null, Validators.required],
      queryType: ['', Validators.required]
    });
  }

  serviceRequest() {
    this.formdetails = this.serviceForm.value
    if (!this.serviceForm.valid) {
      this.toastr.error(this.translate.instant('serviceRequest.fillDetails'))
      return
    }
    const formdata = new FormData()
    let countrycode = this.formdetails.mobile.split(' ')[0];
    formdata.append('vendorEmail', this.vendormailid)
    formdata.append('mobileNumber', this.formdetails.mobile.replace(countrycode + ' ', '').replace(/[.*\-?^${}()|[\]\\]/g, '').replace(/ /g, ''),)
    formdata.append('issuetype', this.formdetails.queryType)
    formdata.append('description', this.formdetails.description)
    formdata.append('file', this.selectedFile)
    this.userservice.postServiceRequest(formdata).subscribe((resp: any) => {
      if (!!resp) {
        this.toastr.success(this.translate.instant('serviceRequest.ticketSuccess'))
        this.cancelrequest();
        this.routeBack();
      } else {
        this.toastr.error(this.translate.instant('serviceRequest.ticketFail'))
      }
    })
  }

  cancelrequest(): void {
    this.serviceForm.markAsPristine();
    this.serviceForm.markAsUntouched();
    this.serviceForm.controls['description'].reset()
    this.serviceForm.controls['mobile'].setValue(this.mobilenumber);
    this.serviceForm.controls['mobile'].updateValueAndValidity();
    this.serviceForm.controls['queryType'].reset()
  }

  routeBack() {
    this.route.navigate(["/dashboard/service-request", { routeID: this.routed.snapshot.paramMap.get('routeID') }]);
  }

  ngOnDestroy() {
    this.subscriptions && this.subscriptions.unsubscribe();
  }
}
